<div class="page-layout carded fullwidth">
  <div class="center px-56">
    <div class="header">
      <span class="h1">{{ 'RATINGS.TITLE' | translate }}</span>

      <div class="page-buttons" fxHide.xs>
        <mat-slide-toggle labelPosition="before" (change)="autoRefresh($event)" [checked]="false">
          {{ 'RATINGS.AUTO_RELOAD' | translate }}
        </mat-slide-toggle>

        <button
          mat-stroked-button
          labelPosition="before"
          [disabled]="isLoading"
          (click)="reload()"
          matTooltip="{{ 'RATINGS.RELOAD' | translate }}"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          mat-stroked-button
          *ngIf="isFiltered"
          matTooltip="{{ 'RATINGS.FILTER_CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>

      <div class="page-buttons" [fxShow]="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuRatings">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuRatings>
          <button class="page-buttons__button" mat-menu-item [disabled]="isLoading" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span>{{ 'RATINGS.RELOAD' | translate }}</span>
          </button>

          <button
            *ngIf="isFiltered"
            class="page-buttons__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="clearFilters()"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span>{{ 'RATINGS.FILTER_CLEAR' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="ratings">
      <div class="card">
        <app-filter></app-filter>
      </div>

      <div class="ratings__numbers" *ngIf="!isLoading">
        <div class="ratings__numbers__content card">
          <span class="ratings__numbers__content__title">{{ 'RATINGS.CARDS.NUMBERS.TOTAL' | translate }}</span>
          <span class="ratings__numbers__content__value--total">{{ dashboardRating.totalCount }}</span>
        </div>

        <div class="ratings__numbers__content card">
          <span class="ratings__numbers__content__title">{{ 'RATINGS.CARDS.NUMBERS.POSITIVE' | translate }}</span>
          <span class="ratings__numbers__content__value--positive">{{ dashboardRating.positiveCount }}</span>
        </div>

        <div class="ratings__numbers__content card">
          <span class="ratings__numbers__content__title">{{ 'RATINGS.CARDS.NUMBERS.NEGATIVE' | translate }}</span>
          <span class="ratings__numbers__content__value--negative">{{ dashboardRating.negativeCount }}</span>
        </div>

        <div class="ratings__numbers__average card" [ngClass]="{ 'low-average': dashboardRating.averageRating <= 3 }">
          <span class="ratings__numbers__average__title">{{ 'RATINGS.CARDS.NUMBERS.AVERAGE' | translate }}</span>
          <div class="ratings__numbers__average__value">
            <span class="ratings__numbers__average__value__number">{{ dashboardRating.averageRating }}</span>
            <stars [rating]="dashboardRating.averageRating" [color]="'#FFFFFF'"></stars>
          </div>
        </div>
      </div>

      <!-- SKELETON-LOADER -->

      <div class="ratings__numbers" *ngIf="isLoading">
        <div class="ratings__numbers__content card" *ngFor="let card of [0, 1, 2]">
          <ngx-skeleton-loader
            [theme]="{ height: '14px', width: '130px', 'margin-bottom': '0px', 'margin-left': '0px' }"
          >
          </ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '20px', width: '40px', 'margin-bottom': '0px', 'margin-left': '0px' }"
          >
          </ngx-skeleton-loader>
        </div>
        <div class="ratings__numbers__content card">
          <ngx-skeleton-loader
            [theme]="{ height: '14px', width: '130px', 'margin-bottom': '0px', 'margin-left': '0px' }"
          >
          </ngx-skeleton-loader>
          <div class="ratings__numbers__average__value">
            <ngx-skeleton-loader
              [theme]="{ height: '20px', width: '40px', 'margin-bottom': '0px', 'margin-left': '0px' }"
            >
            </ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{ height: '20px', width: '120px', 'margin-bottom': '0px', 'margin-left': '0px' }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>

      <!-- /SKELETON-LOADER -->

      <div class="ratings__graphics">
        <div class="card ratings__graphics__byQuantity">
          <div class="ratings__graphics__byQuantity__header">
            {{ 'RATINGS.CARDS.GRAPHIC.QUANTITY.TITLE' | translate }}
          </div>
          <ng-container *ngIf="!byQuantityGraphTotalValue && !isLoading">
            <span class="ratings__graphics__byQuantity__empty">
              {{ 'RATINGS.CARDS.RANKING.NOT_FOUND' | translate }}
            </span>
          </ng-container>
          <vertical-bar-chart
            *ngIf="byQuantityGraphTotalValue"
            [results]="ratingsByQuantity"
            [isLoading]="isLoading"
            [showDataLabel]="false"
            [showGridLines]="true"
            [yAxisTickFormatting]="yAxisFormatToInteger"
            [yAxis]="true"
            color="#FDB22B"
          >
          </vertical-bar-chart>
        </div>

        <div #containerRef class="card ratings__graphics__averageByTimeline">
          <div class="ratings__graphics__averageByTimeline__header">
            {{ 'RATINGS.CARDS.GRAPHIC.AVERAGE.TITLE' | translate }}
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
              <mat-icon
                class="ratings__graphics__averageByTimeline__header__info material-icons-outlined"
                matTooltip="{{ 'RATINGS.CARDS.GRAPHIC.AVERAGE.INFO' | translate }}"
                [matTooltipShowDelay]="500"
                matTooltipPosition="left"
              >
                info
              </mat-icon>

              <chart-date-interval-selector
                [dates]="
                  filter.filterForm.valid
                    ? { from: filter.filterForm.value.initialDate, to: filter.filterForm.value.finalDate }
                    : null
                "
                (activeButtonEvent)="getDateLineChartDateInterval($event)"
              >
              </chart-date-interval-selector>
            </div>
          </div>
          <ng-container *ngIf="!accountRatingsAverageByTimeline && !isLoading">
            <span class="ratings__graphics__averageByTimeline__empty">
              {{ 'RATINGS.CARDS.RANKING.NOT_FOUND' | translate }}
            </span>
          </ng-container>
          <line-chart
            *ngIf="accountRatingsAverageByTimeline && !isLoadingOnlyResponseChart"
            [view]="[containerRef.offsetWidth - 64, 310]"
            [results]="accountRatingsAverageByTimeline"
            [isLoading]="isLoading"
            [xAxis]="true"
            [yAxisTickFormatting]="yAxisFormatToDecimal"
            [yScaleMax]="5.0"
            [yScaleMin]="0"
            [isDateFormat]="true"
          >
          </line-chart>
          <div *ngIf="isLoadingOnlyResponseChart" class="ratings__graphics__averageByTimeline__loading">
            <mat-spinner color="primary" diameter="64"></mat-spinner>
          </div>
        </div>

        <div class="card ratings__graphics__bestRatings">
          <div class="ratings__graphics__bestRatings__header">
            {{ 'RATINGS.CARDS.RANKING.BEST_RATED.TITLE' | translate }}
            <mat-icon
              class="ratings__graphics__bestRatings__header__info material-icons-outlined"
              matTooltip="{{ 'RATINGS.CARDS.RANKING.BEST_RATED.INFO' | translate }}"
              [matTooltipShowDelay]="500"
              matTooltipPosition="left"
            >
              info
            </mat-icon>
          </div>
          <div class="ratings__graphics__bestRatings__content">
            <ng-container *ngIf="bestRatedTasks?.items.length === 0 && !isLoading">
              <span class="ratings__graphics__bestRatings__content__empty">
                {{ 'RATINGS.CARDS.RANKING.NOT_FOUND' | translate }}
              </span>
            </ng-container>

            <ng-container *ngIf="!isLoading">
              <div class="ratings__graphics__bestRatings__content__item" *ngFor="let item of bestRatedTasks.items">
                <span class="ratings__graphics__bestRatings__content__item__maintenance">
                  {{ item.maintenance.number }} - {{ item.maintenance.location?.name }}
                </span>
                <span class="ratings__graphics__bestRatings__content__item__company">
                  {{ item.maintenance.company.name }}
                </span>

                <div class="ratings__graphics__bestRatings__content__item__rating">
                  <stars [rating]="item.ratingStars"></stars>
                  <span class="ratings__graphics__bestRatings__content__item__rating__number">
                    {{ item.ratingStars }}
                  </span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="ratings__graphics__bestRatings__content__item__button"
                  (click)="openMaintenanceDialog(item.maintenance.id)"
                  matTooltip="{{ 'RATINGS.CARDS.RANKING.SEE_DETAILS' | translate }}"
                  matTooltipPosition="right"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12
                  17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                  />
                </svg>
              </div>
            </ng-container>

            <ng-container *ngIf="isLoading">
              <ngx-skeleton-loader
                class="ratings__graphics__worstRatings__content__skeleton"
                [theme]="{ height: '44px', width: '100%', 'margin-bottom': '0px', 'margin-left': '0px' }"
                [count]="10"
              ></ngx-skeleton-loader>
            </ng-container>
          </div>
        </div>

        <div class="card ratings__graphics__worstRatings">
          <div class="ratings__graphics__worstRatings__header">
            {{ 'RATINGS.CARDS.RANKING.WORST_RATED.TITLE' | translate }}
            <mat-icon
              class="ratings__graphics__worstRatings__header__info material-icons-outlined"
              matTooltip="{{ 'RATINGS.CARDS.RANKING.WORST_RATED.INFO' | translate }}"
              [matTooltipShowDelay]="500"
              matTooltipPosition="left"
            >
              info
            </mat-icon>
          </div>
          <div class="ratings__graphics__worstRatings__content">
            <ng-container *ngIf="worstRatedTasks?.items.length === 0 && !isLoading">
              <span class="ratings__graphics__worstRatings__content__empty">
                {{ 'RATINGS.CARDS.RANKING.NOT_FOUND' | translate }}
              </span>
            </ng-container>

            <ng-container *ngIf="!isLoading">
              <div class="ratings__graphics__worstRatings__content__item" *ngFor="let item of worstRatedTasks.items">
                <span class="ratings__graphics__worstRatings__content__item__maintenance">
                  {{ item.maintenance.number }} - {{ item.maintenance.location.name }}
                </span>
                <span class="ratings__graphics__bestRatings__content__item__company">
                  {{ item.maintenance.company.name }}
                </span>

                <div class="ratings__graphics__worstRatings__content__item__rating">
                  <stars [rating]="item.ratingStars" [color]="'#FC3868'"></stars>
                  <span class="ratings__graphics__worstRatings__content__item__rating__number">
                    {{ item.ratingStars }}
                  </span>
                </div>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="ratings__graphics__worstRatings__content__item__button"
                  (click)="openMaintenanceDialog(item.maintenance.id)"
                  matTooltip="{{ 'RATINGS.CARDS.RANKING.SEE_DETAILS' | translate }}"
                  matTooltipPosition="right"
                >
                  <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12
                  17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                  />
                </svg>
              </div>
            </ng-container>

            <ng-container *ngIf="isLoading">
              <ngx-skeleton-loader
                class="ratings__graphics__worstRatings__content__skeleton"
                [theme]="{ height: '44px', width: '100%', 'margin-bottom': '0px', 'margin-left': '0px' }"
                [count]="10"
              ></ngx-skeleton-loader>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
